import React from 'react';
import styled, { css } from 'styled-components';
import { SvgIcon } from '../Icon';
import { IconContainer } from './RightSideBarUI';
import { ITooltipOption } from '../KubitTooltip/globalTooltips';
import { colors } from '../../config/styles';
import KubitTooltip from '../KubitTooltip';

interface IProps {
  isExpanded: boolean;
  onClick: () => void;
  tooltipContent: ITooltipOption;
}

const StyledIconContainer = styled(IconContainer)<{ $isExpanded: boolean }>`
  color: ${colors.purple};
  &:not(:disabled):hover {
    color: ${colors.purple};
    body.dark & {
      color: #fff;
    }
  }

  ${({ $isExpanded }) =>
    $isExpanded &&
    css`
      background-color: ${colors.purple};
      color: #fff;
      &:not(:disabled):hover {
        background-color: ${colors.purple};
        color: #fff;
      }
    `}
`;

const LumosIcon = ({ isExpanded, onClick, tooltipContent }: IProps) => {
  return (
    <KubitTooltip
      {...tooltipContent}
      placement="left"
      noOpenDelay={true}
      disabled={isExpanded}
    >
      <StyledIconContainer
        type="button"
        onClick={onClick}
        $isExpanded={isExpanded}
      >
        <SvgIcon
          name="lumos"
          width={16}
          height={16}
          customFill="currentColor"
        />
      </StyledIconContainer>
    </KubitTooltip>
  );
};

export default LumosIcon;
